<template>
  <div class="svg-container" ref="container">
    <!-- 内容容器 -->
    <div class="svg-content-container">
      <!-- 标题 -->
      <div class="svg-title">
        <div>
          {{ title }}
          <img src="../../../assets/common/title-arrow.png" alt="" />
        </div>
        <div>
          <slot name="icon"></slot>
        </div>
      </div>
      <!-- 标题下边框 -->
      <div class="svg-title-border">
        <img src="../../../assets/common/title-line.png" alt="" />
      </div>
      <div class="svg-content-center"><slot></slot></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default() {
          return '标题'
        },
      },
      bgColor: {
        type: String,
        default() {
          return '#191f21'
        },
      },
    },
    data() {
      return {}
    },
    mounted() {},
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .svg-container {
    position: relative;
    width: 100%;
    height: 100%;
    // 内容容器
    .svg-content-container {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
      text-align: left;
      padding: 15px;
      // 标题
      .svg-title {
        padding: 0 0 0 20px;
        color: white;
        font-size: 16px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        img {
          position: absolute;
          left: 5px;
          width: 6px;
          top: 6px;
        }
      }
      .svg-title-border {
        max-width: 100%;
        overflow: hidden;
        padding-top: 5px;
      }
      // 内容
      .svg-content-center {
        padding-top: 10px;
      }
    }
  }
</style>
